import { Avatar, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AutoPlayFun from "../../functions/AutoPlayFun";
import "./ProfileDrop.css";
import { withFirebase } from '../../auth/firebase';


const ProfileDrop = ({ toggleAutoplay, autoPlay, account, balance, firebase }) => {

  const { darkTheme, toggleDarkTheme } = AutoPlayFun();

  const [user, setUser] = useState();

  useEffect(() => {
    const user = firebase.getCurrentLoginUser();
    setUser(user);
  }, [])

  const changeSwitch = (e) => {
    toggleDarkTheme(e)
    if (e) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  };

  const changeAutoPlay = (e) => {
    toggleAutoplay();
    if (e) {
      const images = document.getElementsByClassName("collectible-img")
      let i = 0
      for (i = 0; i < images.length; i++) {
        images[i].style.visibility = 'visible'
      }
    } else {
      const images = document.getElementsByClassName("collectible-img")
      let i = 0
      for (i = 0; i < images.length; i++) {
        images[i].style.visibility = 'hidden'
      }
    }
  }

  return (
    <div className="profile-drop">
      <div className="profile-drop-header">
        <Avatar
          size="large"
          style={{ background: "#ead3ff", color: "#420080" }}
        >
          {firebase.getCurrentLoginUser() ? firebase.getCurrentLoginUser().displayName.charAt(0) : "Username"}
        </Avatar>
        <div className="profile-drop-header-context">
          <h4>{firebase.getCurrentLoginUser() ? firebase.getCurrentLoginUser().displayName : "S"}</h4>
          <p>{account}</p>
        </div>
      </div>
      <div className="profile-drop-account">
        <div className="profile-drop-header">
          <Avatar
            size="large"
          >
            B
          </Avatar>
          <div className="profile-drop-header-context">
            <p>Balance</p>
            <p>
              <span>{balance} BNB</span> $0.00
            </p>
          </div>
        </div>
        <div className="profile-drop-header">
          <Avatar
            size="large"
            style={{ background: "#e0f7fa", color: "#420080" }}
          >
            B
          </Avatar>
          <div className="profile-drop-header-context">
            <p>Bidding Balance</p>
            <p>
              <span>0 NSFT</span> $0.00
            </p>
          </div>
        </div>
      </div>
      <div className="profile-drop-manage">
        <button>Manage Funds</button>
      </div>
      <div className="profile-drop-menu">
        <div className="profile-drop-menu-item">
          <Link to="/my-items">
            <h3>My Socials</h3>
          </Link>
        </div>
        <div className="profile-drop-menu-item">
          <Link to="/my-items">
            <h3>Edit profile</h3>
          </Link>
        </div>
        <div className="profile-drop-menu-item">
          <h3>Autoplay</h3>
          <Switch checked={autoPlay} onChange={changeAutoPlay} size="small" />
        </div>
        <div className="profile-drop-menu-item">
          <h3>Dark theme</h3>
          <Switch checked={darkTheme} onChange={changeSwitch} size="small" />
        </div>
        <div className="profile-drop-menu-item">
          <h3>Disconnect</h3>
        </div>
      </div>
    </div>
  );
};

export default withFirebase(ProfileDrop);
